
<p-toast></p-toast>
<p-dialog [(visible)]="Visible" [style]="{ width: '450px' }" header="Network Connectivity Status" [modal]="true">
        <ng-template #content>
            <div class="text-center">
              <h3> {{ message }} </h3>
            </div>
        </ng-template>
        <ng-template #footer>
          
        </ng-template>
    </p-dialog>